export const FormFields = {
    ADD_CLOUD_BOTS: 'addCloudBots',
};
